import React from 'react';

function ServiceDetail({ service }) {
    if (!service) {
        return <div className="service-detail-page">Service not found</div>;
    }

    return (
        <div className="service-detail-page">
            <section className="service-hero">
                <div className="container">
                    <div className="service-header">
                        <h1 className="service-title">{service.title}</h1>
                        <div className="service-image-container">
                            <img src={service.image} alt={service.title} className="service-detail-image" />
                        </div>
                    </div>

                    <div className="services-subtitle">Our Services...</div>

                    {service.subtopics && service.subtopics.length > 0 && (
                        <div className="service-subtopics">
                            {service.subtopics.map((subtopic, index) => (
                                <div key={index} className="service-subtopic-item">
                                    <h4 className="service-subtopic-title">{subtopic.title || subtopic}</h4>
                                    <p className="service-subtopic-description">{subtopic.description || ''}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    <p className="service-long-description">
                        {service.longDescription}
                    </p>
                </div>
            </section>
        </div>
    );
}

export default ServiceDetail;
